var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 26,
    rx: 3.5,
    stroke: "#8FC897"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 17.1698L5.83016 12.9998L4.41016 14.4098L10.0002 19.9998L22.0002 7.99984L20.5902 6.58984L10.0002 17.1698Z",
    fill: "#8FC897"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecks);
export default __webpack_public_path__ + "static/media/Checks.8a8d805737b86562ec023608bf0ff31f.svg";
export { ForwardRef as ReactComponent };